import { TFunction } from 'i18next';
import { IDashboardWidgetBaseConfiguration } from '../../../types/IDashboardWidgetBaseConfiguration';
import { getDaysSinceFirstMondayOfYear } from '@/lib/utils/utils';
import { DisplayMode } from '@/types/display-mode.enum';

export class WeeklyBalanceWidgetConfiguration implements IDashboardWidgetBaseConfiguration {
  title = 'dashboard.weeklyBalanceWidgetConfiguration.title';
  locationId = 0;
  assetTypeId = 0;
  periodInWeeks = Math.ceil(getDaysSinceFirstMondayOfYear() / 7); // Default to current week
  displayMode = DisplayMode.HIERARCHICAL;

  // Convert weeks to days for the API call
  get periodInDays(): number {
    return this.periodInWeeks * 7;
  }

  constructor(t: TFunction) {
    this.title = t(this.title);
  }
}
